// src/components/courses/CourseHero.jsx
import React from 'react';
import { motion } from 'framer-motion';

const CourseHero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.5,
        staggerChildren: 0.3,
      },
    },
  };

  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <section className="bg-[url('https://images.unsplash.com/photo-1620641788421-7a1c342ea42e')] bg-cover bg-center py-32 md:py-48 text-white relative flex items-center justify-center">
      <div className="absolute inset-0 bg-black opacity-60"></div>
      <div className="container mx-auto px-4 relative z-10 text-center">
        <motion.div
          className="max-w-xl mx-auto"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.h1
            className="text-4xl font-bold font-heading mb-6 md:text-5xl lg:text-6xl"
            variants={textVariants}
          >
            Explore Our Comprehensive Courses
          </motion.h1>
          <motion.p
            className="text-lg mb-8 md:text-xl"
            variants={textVariants}
            transition={{ delay: 0.6 }}
          >
            Elevate your learning with our expertly designed courses for medical aspirants.
          </motion.p>
          {/* You might want different buttons for the courses page */}
          {/* <motion.div
            className="flex justify-center gap-4"
            variants={buttonVariants}
            transition={{ delay: 0.9 }}
          >
            <motion.button
              className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-6 rounded-full focus:outline-none focus:shadow-outline transition duration-300"
              whileHover="hover"
            >
              View All Courses
            </motion.button>
            <motion.button
              className="bg-transparent border border-white hover:border-purple-500 text-white font-bold py-3 px-6 rounded-full focus:outline-none focus:shadow-outline transition duration-300"
              whileHover="hover"
            >
              Featured Courses
            </motion.button>
          </motion.div> */}
        </motion.div>
      </div>
    </section>
  );
};

export default CourseHero;